const encode = encodeURIComponent;

export default (requests, axios) => {
    return {

        getVirutalGames: (provider, format) => {
            return requests.get(`/integration/${provider}/${format}`);
        },

        getVirutalGame: (provider, gameId) => {
            return requests.get(`/integration/${provider}/get_game?gameid=${gameId}`);
        },

        getSimpleIframeGame: (provider, gameId = null) => {
            return process.env.TVBET_START_URL_GAME && gameId
                ? requests.get(`/integrations/${provider}/iframe?gameId=${gameId}${Boolean(process.env.TVBET_WITH_REG_METHOD) ? '&regMethod=1' : ''}`)
                : requests.get(`/integrations/${provider}/iframe${Boolean(process.env.TVBET_WITH_REG_METHOD) ? '?regMethod=1' : ''}`
                );
        },

        getIntegration: ({ provider, method }) => {
            return requests.get(`/integration/${provider}/${method}`)
        },

        getGoldenRaceGame: ({ device = 'WEB', demo = true, countryCode = '' }) => {
            return requests.get(`/integrations/goldenrace/get_game/${device.toUpperCase()}?demo=${demo}&countryCode=${countryCode}`)
        },

        getIWGgamesList: () => {
            return requests.get(`/integrations/solidicon/game_list?isMobile=false`);
        },

        getIWGgame: (gameId, realPlay) => {
            return requests.get(`/integrations/solidicon/get_game?gameId=${gameId}&realPlay=${realPlay}&isMobile=false`);
        },

        getBetgeniusStreamingUrl: ({ fixtureId, liveStreamId, deliveryType, deliveryTypeId, device, countryCode, deviceId }) => {
               const path = [
                encode(fixtureId || ''),
                encode(liveStreamId || ''),
                encode(deliveryType || ''),
                encode(deliveryTypeId || ''),
                encode(device || ''),
                encode(countryCode || '')
            ].join('/');
            return requests.get(`/integrations/betgenius/streaming/${path}?deviceId=${deviceId}`);
        }
    }
};
